import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { Facebook } from 'blaze-ui/icons'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { postLength } from './shared/postLength'
import { seoWords } from './shared/seoWords'
import { includeImages } from 'components/Wizards/schemas/shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { PostLength } from '../ContentPlanning/utils'
import { crossPostAccounts } from './shared/crossPostAccounts'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'
import { includeEmojis } from './shared/includeEmojis'

const meta = {
  type: ChannelType.FacebookPost,
  icon: Facebook,
  steps: ['Context', 'Generate Post'],
  title: TextChannels[ChannelType.FacebookPost].name,
  submitLabel: 'Generate Post',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183539/Home%20Card%20Previews/al5zz4ccpembjakoo10p.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your Facebook post?', generationType: meta.type }),
  include_emojis: includeEmojis,
  seo_words: seoWords.meta({ label: 'What keywords should be included?' }),
  post_length: postLength
    .required()
    .oneOf([
      PostLength.FiveToTenWords,
      PostLength.TenToTwentyFiveWords,
      PostLength.TwentyFiveToFiftyWords,
      PostLength.FiftyToSeventyFiveWords,
      PostLength.SeventyFivetoOneHundredWords,
      PostLength.OneHudredPlusWords,
    ])
    .default(PostLength.TenToTwentyFiveWords),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your posts far more engaging and attention grabbing',
  }),
  cross_post_accounts: crossPostAccounts,
}

export const FacebookPostsSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const FacebookPostsMultiStepSchema: MultiStepSchema<ChannelType.FacebookPost> = {
  steps: [
    FacebookPostsSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.FacebookPost,
    channel: ChannelType.FacebookPost,
  },
}
